import { ReactNode } from 'react';

import { Box } from '@mui/material';

/**
 * Renders a label with a red asterisk if the field is required.
 *
 * @param label - The field label to render
 * @param isRequired - Whether the field is required
 * @returns A JSX element or undefined
 */
export function renderRequiredLabel(
  label?: ReactNode,
  isRequired?: boolean,
): ReactNode {
  if (!label) return undefined;

  return (
    <Box component="span">
      {label}
      {isRequired && (
        <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>
          *
        </Box>
      )}
    </Box>
  );
}
